<div class="modal-header">
    <h4 class="modal-title">Copy User to Companies</h4>
    <button type="button" class="close" aria-label="Close" (click)="cancel()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body" style="max-height: 70vh; overflow-y: auto; padding: 20px;">
    <div class="row">
        <div class="col-md-12">
            <h5 style="margin-bottom: 15px;">User: {{ user?.Title }} {{ user?.FirstName }} {{ user?.LastName }}</h5>
            <p style="color: #666; margin-bottom: 20px;">
                Select the companies where this user will be copied. The user's current designation, director type, and category will be pre-selected.
            </p>
            
            <!-- Companies Table -->
            <div class="row" *ngIf="allCompaniesList && allCompaniesList.length > 0">
                <div class="col-md-12">
                    <div class="table-responsive" style="max-height: 500px; overflow-y: auto; border: 1px solid #ddd; border-radius: 4px;">
                        <table class="table table-hover table-bordered" style="margin-bottom: 0; width: 100%; table-layout: auto;">
                            <thead style="background-color: #f5f5f5; position: sticky; top: 0; z-index: 10;">
                                <tr>
                                    <th style="width: 50px; text-align: center;">
                                        <input type="checkbox" id="selectAllCompanies" 
                                            [checked]="areAllCompaniesSelected()"
                                            [indeterminate]="areSomeCompaniesSelected()"
                                            (change)="toggleSelectAllCompanies($event)">
                                    </th>
                                    <th style="width: 180px;">Company Name</th>
                                    <th style="width: 110px; text-align: center;">
                                        Board Member
                                        <div style="font-size: 11px; font-weight: normal; color: #666;">YES / NO</div>
                                    </th>
                                    <th style="width: 90px; text-align: center;">
                                        KMP
                                        <div style="font-size: 11px; font-weight: normal; color: #666;">YES / NO</div>
                                    </th>
                                    <th style="width: 180px;">
                                        Director Type
                                        <div style="font-size: 11px; font-weight: normal; color: #666;">Dropdown default selection but editable</div>
                                    </th>
                                    <th style="width: 200px;">
                                        Designation
                                        <div style="font-size: 11px; font-weight: normal; color: #666;">Dropdown default selection but editable</div>
                                    </th>
                                    <th style="width: 150px;">
                                        Category
                                        <div style="font-size: 11px; font-weight: normal; color: #666;">Dropdown default selection but editable</div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let company of allCompaniesList; let i = index" 
                                    [class.table-active]="selectedCompanies[i]?.isSelected">
                                    <td style="text-align: center;">
                                        <input type="checkbox" 
                                            [checked]="selectedCompanies[i]?.isSelected"
                                            (change)="onCompanySelectionChange(i, $event)">
                                    </td>
                                    <td style="font-weight: 500;">{{ company.CompanyName }}</td>
                                    <td style="text-align: center;">
                                        <div class="form-check form-check-inline" style="margin: 0;">
                                            <input class="form-check-input" type="checkbox" 
                                                [checked]="selectedCompanies[i]?.isBoardMember"
                                                [disabled]="!selectedCompanies[i]?.isSelected"
                                                (change)="onBoardMemberChange(i, $event)"
                                                id="boardMember_{{i}}">
                                            <label class="form-check-label" for="boardMember_{{i}}" style="margin-left: 5px;">
                                                {{ selectedCompanies[i]?.isBoardMember ? 'YES' : 'NO' }}
                                            </label>
                                        </div>
                                    </td>
                                    <td style="text-align: center;">
                                        <div class="form-check form-check-inline" style="margin: 0;">
                                            <input class="form-check-input" type="checkbox" 
                                                [checked]="selectedCompanies[i]?.isKMP"
                                                [disabled]="!selectedCompanies[i]?.isSelected"
                                                (change)="onKMPChange(i, $event)"
                                                id="kmp_{{i}}">
                                            <label class="form-check-label" for="kmp_{{i}}" style="margin-left: 5px;">
                                                {{ selectedCompanies[i]?.isKMP ? 'YES' : 'NO' }}
                                            </label>
                                        </div>
                                    </td>
                                    <td>
                                        <ng-select [items]="directorTypesList" 
                                            bindLabel="label" 
                                            bindValue="value"
                                            [formControl]="companyFormArray.at(i).get('directorType')"
                                            [ngModel]="selectedCompanies[i]?.directorType"
                                            (change)="onCompanyDirectorTypeChange(i, $event)"
                                            placeholder="Select Director Type"
                                            [clearable]="true"
                                            [disabled]="!selectedCompanies[i]?.isSelected || !selectedCompanies[i]?.isBoardMember"
                                            [searchable]="true">
                                        </ng-select>
                                    </td>
                                    <td>
                                        <!-- Show KMP designations if KMP is selected -->
                                        <ng-select *ngIf="selectedCompanies[i]?.isKMP && !selectedCompanies[i]?.isBoardMember"
                                            [items]="kmpDesignationList" 
                                            bindLabel="label" 
                                            bindValue="value"
                                            [formControl]="companyFormArray.at(i).get('designation')"
                                            [ngModel]="selectedCompanies[i]?.designation"
                                            (change)="onCompanyDesignationChange(i, $event)"
                                            placeholder="Select Designation"
                                            [clearable]="true"
                                            [disabled]="!selectedCompanies[i]?.isSelected"
                                            [searchable]="true">
                                        </ng-select>
                                        <!-- Show Board Member designations if Board Member is selected (and not KMP) -->
                                        <ng-select *ngIf="selectedCompanies[i]?.isBoardMember && !selectedCompanies[i]?.isKMP"
                                            [items]="boardDesignationlist" 
                                            bindLabel="label" 
                                            bindValue="value"
                                            [formControl]="companyFormArray.at(i).get('designation')"
                                            [ngModel]="selectedCompanies[i]?.designation"
                                            (change)="onCompanyDesignationChange(i, $event)"
                                            placeholder="Select Designation"
                                            [clearable]="true"
                                            [disabled]="!selectedCompanies[i]?.isSelected"
                                            [searchable]="true">
                                        </ng-select>
                                        <!-- If both are selected, show Board Member designations -->
                                        <ng-select *ngIf="selectedCompanies[i]?.isBoardMember && selectedCompanies[i]?.isKMP"
                                            [items]="boardDesignationlist" 
                                            bindLabel="label" 
                                            bindValue="value"
                                            [formControl]="companyFormArray.at(i).get('designation')"
                                            [ngModel]="selectedCompanies[i]?.designation"
                                            (change)="onCompanyDesignationChange(i, $event)"
                                            placeholder="Select Designation"
                                            [clearable]="true"
                                            [disabled]="!selectedCompanies[i]?.isSelected"
                                            [searchable]="true">
                                        </ng-select>
                                        <!-- Show disabled placeholder if neither is selected -->
                                        <ng-select *ngIf="!selectedCompanies[i]?.isKMP && !selectedCompanies[i]?.isBoardMember"
                                            [items]="[]" 
                                            placeholder="Select Board Member or KMP first"
                                            [disabled]="true">
                                        </ng-select>
                                    </td>
                                    <td>
                                        <ng-select [items]="categoryList" 
                                            bindLabel="label" 
                                            bindValue="value"
                                            [formControl]="companyFormArray.at(i).get('category')"
                                            [ngModel]="selectedCompanies[i]?.category"
                                            (change)="onCompanyCategoryChange(i, $event)"
                                            placeholder="Select Category"
                                            [clearable]="true"
                                            [disabled]="!selectedCompanies[i]?.isSelected || !selectedCompanies[i]?.isBoardMember"
                                            [searchable]="true">
                                        </ng-select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div *ngIf="getSelectedCompaniesCount() > 0" 
                        style="margin-top: 15px; padding: 10px; background-color: #e7f3ff; border-radius: 4px;">
                        <strong>{{ getSelectedCompaniesCount() }}</strong> 
                        company/companies selected
                    </div>
                </div>
            </div>
            
            <!-- Loading or Empty State -->
            <div class="row" *ngIf="!allCompaniesList || allCompaniesList.length === 0">
                <div class="col-md-12" style="text-align: center; padding: 40px; color: #999;">
                    <p>Loading companies...</p>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-primary btn-sm" 
        [disabled]="getSelectedCompaniesCount() === 0"
        (click)="save()">Copy to Selected Companies</button>
    <button class="btn btn-sm" (click)="cancel()">Cancel</button>
</div>

